/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ScriptExecutionLog
 */
export interface ScriptExecutionLog {
    /**
     * 
     * @type {string}
     * @memberof ScriptExecutionLog
     */
    message?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScriptExecutionLog
     */
    date?: Date;
}

/**
 * Check if a given object implements the ScriptExecutionLog interface.
 */
export function instanceOfScriptExecutionLog(value: object): boolean {
    return true;
}

export function ScriptExecutionLogFromJSON(json: any): ScriptExecutionLog {
    return ScriptExecutionLogFromJSONTyped(json, false);
}

export function ScriptExecutionLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScriptExecutionLog {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
    };
}

export function ScriptExecutionLogToJSON(value?: ScriptExecutionLog | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'message': value['message'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString()),
    };
}

